import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { softwareSummaryEmbedClassicRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareSummaryEmbedClassicRoute.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { summarySoftwareEmbedEntrypoint } from '@atlassian/jira-spa-apps-summary/software-embed/entrypoint.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';

const summarySoftwareEmbedPageEntrypoint = createChromelessEntryPoint({
	main: summarySoftwareEmbedEntrypoint,
});

export const softwareSummaryEmbedClassicRouteEntry = createEntry(
	softwareSummaryEmbedClassicRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'classic-summary',
		layout: chromelessLayout,

		resources: [
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			// end of resources expanded from getNavigationSidebarProjectResource
		],

		entryPoint: () => {
			return summarySoftwareEmbedPageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-classic-projects-entries/src/softwareSummaryEmbedClassicRouteEntry.tsx',
				whichExportToUse: 'softwareSummaryEmbedClassicRouteEntry',
			},

			enabled: true,
		},
	}),
);
